<!-- Localized -->
<template>
    <div v-if="open" class="addblocktosection flex-col h-screen w-screen flex items-center justify-center fixed inset-0" @click.stop="closeModal()">
        <div class="h-auto flex-col px-6 py-3 space-y-4 flex items-center justify-center rounded-md" @click.stop>
            <div class="flex space-x-6" style=" height: auto">
                <div class="max-h-full w-full  max-w-md  overflow-y-auto flex flex-col">
                    <div class="bg-primary p-2 rounded-t-lg text-white-text font-semibold flex items-center justify-between">
                        {{ $t('profile_view.delete_case', { value : case_id }) }}
                        <button class="bg-white cursor-pointer rounded-full h-6 w-6 justify-center items-center flex" @click="closeModal()">
                            <font-awesome-icon icon="times" class="text-gray-800" />
                        </button>
                    </div>
                    <div class="bg-card-bg rounded-b-lg flex-1 h-full p-5 flex flex-col overflow-y-auto max-w-full">
                        <!-- <div class="text-gray-700 mb-3"> <strong> {{ $t('profile_view.case_id') }}  </strong>: {{ case_id }} </div> -->
                       <label for="#" class="text-sm block mb-2">{{ $t('profile_view.confirm_delete_selected_case', { value : case_id }) }}</label>
                        <div class="flex space-x-6 mb-6">
                            <div class="form-control">
                                <label class="label cursor-pointer">
                                <input type="radio" class="flex-shrink-0 h-5 w-5 text-dvbrandcolor" @change="confirmInput = ''" value="yes" v-model="confirmDelete" />
                                    <span class="label-text ml-3">{{ $t('general.yes') }}</span> 
                                </label>
                            </div>
                            <div class="form-control">
                                <label class="label cursor-pointer">
                                <input type="radio" class="flex-shrink-0 h-5 w-5 text-dvbrandcolor"  @change="confirmInput = ''" value="no" v-model="confirmDelete" />
                                    <span class="label-text ml-3">{{ $t('general.no') }}</span> 
                                </label>
                            </div>
                        </div>
                        <template v-if="confirmDelete === 'yes'">
                            <div v-if="monitorinStatus" class="bg-red-100 text-red-700 px-4 py-3 rounded-md relative" role="alert">
                                <strong class="font-semibold">{{ $t('profile_view.please_note') }}</strong>
                                <span class="block sm:inline"> 
                                    {{ $t('profile_view.permanent_delete_with_monitoring', { value : case_id }) }}</span>
                            </div>
                            <div v-else class="bg-red-100 text-red-700 px-4 py-3 rounded-md relative" role="alert">
                                <strong class="font-semibold">{{ $t('profile_view.please_note') }}</strong>
                                <span class="block sm:inline">
                                    {{ $t('profile_view.permanent_delete_without_monitoring', { value : case_id }) }}</span>
                            </div>
                            <div class="py-3 px-1">
                                <label for="#" class="text-sm block mb-2">{{ $t('profile_view.confirm_delete_case') }}</label>
                                <div class="form-control mb-6">
                                    <input type="text" :placeholder="$t('profile_view.enter_yes_here')"   v-model.trim="confirmInput"  class="form input-bordered input focus:input-primary" />
                                </div>
                            </div>
                        </template>
                        <div class="grid grid-cols-2 gap-x-6 ">
                            <button class="bg-gray-200 hover:bg-gray-300 transition-colors  hover:text-gray-700 text-gray-600 px-8 font-medium py-3.5 rounded-xl " @click="closeModal">{{ $t('actions.cancel') }}</button>
                            <button class="bg-gray-200   transition-colors text-gray-600 px-8 font-medium py-3.5 rounded-xl " :disabled="!isBtnDisabled || isDeleteLoading" 
                            :class="{'pointer-events-none': !isBtnDisabled || isDeleteLoading, 'btn-red': isBtnDisabled}" @click="$emit('handle-delete')" >
                            {{ $t('actions.delete') }}
                            </button>

                        </div>
                    </div>
                </div>  
            </div>
        </div>
    </div>
</template>

<script>
// import ListView from "@shared/components/list-view";
// import Loader from "@shared/components/loader"
// import Input from "@shared/input"
export default {
    data() {
        return {
            confirmDelete: 'no',
            confirmInput: '',
            activeDetail: null,
            showDetailsPanel: false,
            searchKeyword: ""
        }
    },
    props: {
        open: {
            default: false,
            type: Boolean,
        },
        loadingLists: {
            type: Boolean,
            default: false,
        },
        isDeleteLoading: {
            type: Boolean,
            default: false,
        },
        monitorinStatus: {
             type: Boolean,
            default: false,
        },
        usedInDetails: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        case_id(){
            return this.$route?.params?.caseid
        },
        isBtnDisabled() {
            return this.confirmInput.toLowerCase() === 'yes'
        },
        
    },
    
    components: {
        // ListView,
        // Loader,
        // Input
    },
    methods: {
        handleFilterResult(str) {
            this.searchKeyword = str || ""
        },
        closeModal() {
            // this.handleSelect(this.activeElement);
            this.confirmInput  = ''
            this.confirmDelete = 'no'
            this.closeDetailsPanel()
            this.$emit("close");
        },
        closeDetailsPanel() {
            this.searchKeyword = ''
            this.activeDetail = null 
            this.showDetailsPanel = false 
        },
        showDetails(used) {
            this.searchKeyword = ''

            this.activeDetail = used 
            this.showDetailsPanel = true 
            console.log('used :>> ', used);
        },
        
    }

}
</script>

<style lang="scss" scoped>
.addblocktosection {
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 9999;
}
.btn-red{
    background: #ff7777;
    color: #fff;
    &:hover {
        background: #f17474;

    }
}
</style>